import { useSearchParams } from 'react-router'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { PAGINATION_PAGE_PARAM } from '../../../../../constants/pagination'
import { useTimeZone } from '../../../../../hooks'

import {
  getViewingsClearedFilterParamList,
  getViewingsFilterBarValues,
  getViewingsFilterParams,
  getViewingsFilterValues,
} from './useRentalPortalViewingsFilters.utils'

export function useRentalPortalViewingsFilters({ availableFilters }) {
  const [searchParams, setSearchParams] = useSearchParams()

  const timezone = useTimeZone()

  const filterValues = getViewingsFilterValues({
    availableFilters,
    searchParams,
    timezone,
  })

  const filterBarValues = getViewingsFilterBarValues({
    availableFilters,
    filterValues,
    timezone,
  })

  function handleSetFilterValues(nextFilterValues) {
    setSearchParams(
      params => {
        params.delete(PAGINATION_PAGE_PARAM)

        getViewingsClearedFilterParamList(availableFilters).forEach(param =>
          params.delete(param)
        )

        getViewingsFilterParams({
          availableFilters,
          filterValues: nextFilterValues,
          timezone,
        }).forEach(([param, value]) => params.append(param, value))

        return params
      },
      { replace: true }
    )
  }

  function handleClearFilters() {
    handleSetFilterValues(EMPTY_OBJECT)
  }

  return {
    filterBarValues,
    filterValues,
    handleClearFilters,
    handleSetFilterValues,
  }
}
